import { CORPORATE_DELIVERY_STEPS, CORPORATE_SOLUTIONS } from "../CorporatePortalContent";

export default function CorporateSolutionsPage() {
  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">业务方向</h1>
          <p className="corporate-page-banner-desc">
            三大主攻方向：AI 产研组织赋能、大V 数字人知识平台、AI 影视内容生产。
          </p>
        </div>
      </section>

      <div className="corporate-page">
        {CORPORATE_SOLUTIONS.map((item, index) => (
          <section
            key={item.id}
            className="corporate-section"
            style={{ paddingTop: index === 0 ? 40 : 56 }}
          >
            <div className="corporate-tag-list" style={{ marginBottom: 12 }}>
              {item.tags.map((tag) => (
                <span key={tag} className="corporate-tag">
                  {tag}
                </span>
              ))}
              {item.status === "research" ? (
                <span className="corporate-tag" style={{ opacity: 0.7 }}>
                  持续调研中
                </span>
              ) : null}
            </div>
            <h2 className="corporate-section-title" style={{ paddingTop: 0 }}>
              {item.title}
            </h2>
            <p className="corporate-section-desc">{item.summary}</p>

            {item.modules ? (
              <div className="corporate-card-grid">
                {item.modules.map((mod) => (
                  <div key={mod.name} className="corporate-card">
                    <h3 className="corporate-card-title">{mod.name}</h3>
                    <p className="corporate-card-text">{mod.desc}</p>
                    <ul className="corporate-highlight-list">
                      {mod.points.map((point) => (
                        <li key={point}>{point}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              <ul className="corporate-highlight-list">
                {item.highlights.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <section className="corporate-section">
          <h2 className="corporate-section-title">组织赋能交付流程</h2>
          <p className="corporate-section-desc">
            以 AI + 组织管理为例，从认知到落地再到系统化的完整路径。
          </p>
          <div className="corporate-card-grid corporate-card-grid-3">
            {CORPORATE_DELIVERY_STEPS.map((step) => (
              <div key={step.title} className="corporate-card">
                <h3 className="corporate-card-title">{step.title}</h3>
                <p className="corporate-card-text">{step.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
